<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
<p-fieldset>

    <ng-template pTemplate="header">{{lbl_participants}}</ng-template>
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{lbl_back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2" (click)="goBack()"></button>
        </ng-template>
    
        <!--<ng-template pTemplate="right">
            <p-fileUpload mode="basic" accept="image/*" [maxFileSize]="1000000" label="Import" chooseLabel="Import" class="p-mr-2 p-d-inline-block"></p-fileUpload>
            <button pButton pRipple label="Export" icon="pi pi-upload" class="p-button-help"></button>
        </ng-template>-->
    </p-toolbar>

    <div class="card">
        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <p-panel>
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{lbl_name}}</span>
                        <span class="p-text-bold">{{guide != null ? guide.name + " " + guide.lastName: ""}}</span>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{lbl_certificate}}</span>
                        <span class="p-text-bold">{{guide != null ? guide.certif : ""}}</span>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{lbl_email}}</span>
                        <span class="p-text-bold">{{guide != null ? guide.email : ""}}</span>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{lbl_cell_phone}}</span>
                        <span class="p-text-bold">{{guide != null ? guide.mobPhon : ""}}</span>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{lbl_digitized_document}}</span>
                        <button pButton pRipple type="button" icon="pi pi-file-pdf" class="p-button-rounded p-button-info" *ngIf="guide !=null && guide.uploadCertif" (click)="downloadCertificate()"></button>
                        <button pButton pRipple type="button" icon="pi pi-file-pdf" class="p-button-rounded p-button-info" *ngIf="guide !=null && !guide.uploadCertif" disabled="true"></button>
                    </div>

                    <div class="p-mr-2 p-mb-2">
                        <!--button pButton pRipple type="button" icon="pi pi-plus" label="Certificado" class="p-button-raised p-button-success" ></button-->
                        <p-fileUpload  mode="basic"   icon="pi pi-plus"  maxFileSize="5000000" (onSelect)="onUploadCertificate($event)"  [auto]="true" chooseLabel="{{lbl_upload_file}} PDF" accept="application/pdf"></p-fileUpload>
                    </div>
                   
                </p-panel>
            </div>

            <div class="p-col-12 p-md-6">
                <div class="p-d-flex">
                    <p-card header="" subheader="{{lbl_photo}}" styleClass="p-card-shadow">
                        <ng-template pTemplate="header">
                            <img alt="Card" src="assets/layout/images/not-file.png" *ngIf="guide !=null && !guide.uploadPhoto">
                            <img alt="Card" [src]="imageToShow" *ngIf="guide !=null && guide.uploadPhoto">
                        </ng-template>
                        <ng-template pTemplate="footer">
                            <!--p-button label="Actualizar" icon="pi pi-check"></p-button-->
                            <p-fileUpload  mode="basic"   icon="pi pi-plus"  maxFileSize="5000000" (onSelect)="onUploadPhoto($event)"  [auto]="true" chooseLabel="{{lbl_upload_file}} JPG" accept="image/jpeg"></p-fileUpload>
                            <!--p-button label="Cancel" icon="pi pi-times" styleClass="p-button-secondary" [style]="{'margin-left': '.5em'}"></p-button-->
                        </ng-template>
                    </p-card> 
                </div>
            </div>

        </div>
    </div>



</p-fieldset>